// Module
var code = `<!--
<div class="branding">
  <a
    class="site-title-text logo-link"
    href="/"
    aria-label="Home"
    data-channel="ROUTE"
    data-end-route="true"
    data-page-id="home"
    data-event-prevent-default="true"
  >
  </a>
</div>
-->
`;
// Exports
module.exports = code;